<template>
  <div>
    <h1>{{ questionLabel }}</h1>

    <div class="response">
      <vv-valid v-if="responseIsValid" class="response-box">
        <green-check class="response-icon" />
        <div class="response-text">
          <p class="user-response">{{ userResponseLabel }}</p>
          <p class="indicator right-response">{{ $t('quiz.rightResponse') }}</p>
        </div>
      </vv-valid>

      <vv-invalid v-else class="response-box">
        <red-cross class="response-icon" />
        <div class="response-text">
          <p class="user-response">{{ userResponseLabel }}</p>
          <p class="indicator wrong-response">{{ $t('quiz.wrongResponse') }}</p>
          <p>
            {{ $t('quiz.rightResponseWas') }}
            <br />
            <span class="expected-response">« {{ validResponseLabel }} »</span>
          </p>
        </div>
      </vv-invalid>
    </div>

    <div class="explanation" v-if="question.explanation">
      <vv-speech-bubble :title="$t('quiz.vinovibesExplains')">
        <vv-rich-text :document="question.explanation" />
      </vv-speech-bubble>
    </div>
  </div>
</template>

<script>
import { VvInvalid, VvRichText, VvSpeechBubble, VvValid } from '@/components/common'
import GreenCheck from '@/components/layout/svg/GreenCheck'
import RedCross from '@/components/layout/svg/RedCross'

export default {
  name: 'SingleResponseItem',
  components: { GreenCheck, RedCross, VvInvalid, VvRichText, VvSpeechBubble, VvValid },
  props: {
    questionId: String
  },
  computed: {
    question() {
      return this.$store.state.quiz.question.byId[this.questionId]
    },
    userResponse() {
      return this.$store.state.quiz.userResponses.byId[this.questionId]
    },
    responseIsValid() {
      return this.question.expectedResponse.choice === this.userResponse.choice
    },
    questionLabel() {
      return this.question.data.question
    },
    userResponseLabel() {
      const choice = this.question.data.choices[this.userResponse.choice]
      return choice.label
    },
    validResponseLabel() {
      const validResponse = this.question.data.choices[this.question.expectedResponse.choice]
      return validResponse.label
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/response.scss';
</style>
